"use client";

import { useState } from "react";

type NavigatorWithUserAgentData = Navigator & {
  userAgentData?: { platform?: string };
};

export function useIsWindows(): boolean {
  const [isWindows] = useState(() => {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent ?? "";
    const platform =
      (navigator as NavigatorWithUserAgentData).userAgentData?.platform ??
      navigator.platform ??
      "";

    return /Windows/i.test(ua) || /Win/i.test(platform);
  });

  return isWindows;
}
